import script from "./hospitalInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./hospitalInfo.vue?vue&type=script&setup=true&lang=js"

import "./hospitalInfo.vue?vue&type=style&index=0&id=5cc8acb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cc8acb0"]])

export default __exports__